export const TEAM_SEAT_PRICE = 12;
export const TEAM_BASE_SEATS = 2;
export const TEAM_BASE_PRICE = 25;

export const MILLISECONDS_IN_DAY = 24 * 3600 * 1000;
